export const getPromoCodeFromRedirect = (redirectUrl: string) =>
  new URL(redirectUrl, 'https://www.daymade.co.uk').searchParams.get('pc');

export const getPromoCodeForLoginRedirect = (
  redirectUrl: string,
  loginQueryPromoCode?: string,
) => loginQueryPromoCode || getPromoCodeFromRedirect(redirectUrl);
